import {
  SET_CURRENT_STOP,
  CurrentStopActionTypes,
} from "./currentStop.Actions";

const initialState = { currentStop: -1, stopsVisitedCount: 0 };

const CurrentStopReducer = (
  state = initialState,
  action: CurrentStopActionTypes
) => {
  switch (action.type) {
    case SET_CURRENT_STOP: {
      const { currentStop } = action.payload;
      let visitedCount = state.stopsVisitedCount;
      if (currentStop > -1) {
        visitedCount += 1;
      }
      return {
        currentStop,
        stopsVisitedCount: visitedCount,
      };
    }
    default:
      return state;
  }
};

export default CurrentStopReducer;
